<template>

    <li class="p-2 text-sm text-theme-main flex flex-row items-center hover:bg-theme-level4 cursor-pointer hover-vis-trigger rounded-md" :class="{'bg-theme-level4' : thisItemIsPlaying}" @click.stop="playThisItem">

        <img v-if="playlistItem.legacy" :src="legacy_thumbnail" @error="$event.target.src=default_thumbnail" alt="thumbnail" style="width: 80px; height: 45px;" class="mr-4">
        <img v-else :src="thumbnail" alt="thumbnail" style="width: 80px; height: 45px;" class="mr-4">

        <p class="flex flex-col w-4/5">
            <span class="font-bold mb-2">{{ playlistItem.title }}</span>
            <span>{{ playlistItem.publish_date }}</span>
        </p>

    </li>

</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        data() {

            return {

                playlistItem: this.item,

            }

        },

        props: [

            'currentlocale',
            'item',
            'thumbnail',
            'legacy_thumbnail',
            'default_thumbnail'

        ],

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            playThisItem() {
                window.history.pushState({ "pageTitle": this.playlistItem.title }, this.playlistItem.title, '/' + this.currentlocale + '/content/' + this.playlistItem.id)

                /*this.$root.shared.playerPayload = this.playlistItem
                this.$root.shared.isLegacyContent = !!this.playlistItem.legacy*/

                Event.fire('showPlayer', { language: this.currentlocale, data: this.item });
                this.thisItemIsPlaying = true
                // Event.fire('updateVideoPlayer', this.item)
            },

        },

        computed: {

            thisItemIsPlaying: {
                get() {
                    return (this.$root.shared.currentlyPlayingContentId === this.item.id)
                },

                set(value) {
                    return value
                }
            }

        }

    }

</script>
